import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingOverlayService {
  private readonly _loading$ = new BehaviorSubject<boolean>(false);

  readonly isLoading$ = this._loading$.asObservable();

  show(): void {
    if (!this._loading$.value) {
      this._loading$.next(true);
    }
  }

  hide(): void {
    if (this._loading$.value) {
      this._loading$.next(false);
    }
  }
}
